import { Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __extends, __assign } from 'tslib';
import { END_STATE, domTool } from '@tencent/thumbplayer-core';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".txp_poster_img{position:absolute;left:0;top:0;width:100%;height:100%;z-index:2;-o-object-fit:contain;object-fit:contain}.txp_poster_img.txp_none{display:none}";
styleInject(css_248z);

/* eslint-disable @typescript-eslint/naming-convention */
var PosterPluginName = 'poster';
var hideClass = 'txp_none';
var POSTER_IMAGE_ALT = 'Thumbplayer Poster Plugin Image';
var POSTER_IMAGE_CLASS_NAME = 'txp_poster_img';

var DEFAULT_RES = ['496', '360', '228'];
function findPoster(_a) {
    var vid = _a.vid, resolution = _a.resolution, _b = _a.vidFirstPic, vidFirstPic = _b === void 0 ? false : _b, h5Defn = _a.h5Defn, _c = _a.dir, dir = _c === void 0 ? 'hz' : _c;
    if (vidFirstPic) {
        // 选择显示首帧图（貌似首帧图只有一个分辨率）
        return "https://puui.qpic.cn/vpic_cover/" + vid + "/" + vid + "_first.jpg/" + (dir === 'hz' ? '640x360' : '360x640');
    }
    var res = resolution || DEFAULT_RES[h5Defn];
    if (res) {
        // 预设的分辨率只有横图
        return "https://puui.qpic.cn/vpic_cover/" + vid + "/" + vid + "_hz.jpg/" + (resolution || DEFAULT_RES[h5Defn] || '0');
    }
    return "https://puui.qpic.cn/vpic_cover/" + vid + "/" + vid + "_" + dir + ".jpg";
}
/**
 * Thumbplayer-H5 poster插件（由于video标签是在play/load方法时插入，没有办法使用H5原生的poster属性）
 */
var PosterPlugin = /** @class */ (function (_super) {
    __extends(PosterPlugin, _super);
    function PosterPlugin(player, config, extra) {
        var _a;
        var _this = _super.call(this, player, config, extra) || this;
        _this.config = __assign(__assign({}, (player.config.poster || {})), config);
        _this.objectFitMode = (_a = player.config.videoElementConfig) === null || _a === void 0 ? void 0 : _a.objectFit;
        _this.el = _this.init();
        _this.tryShow();
        return _this;
    }
    PosterPlugin.prototype.destroy = function () {
        var _a;
        _super.prototype.destroy.call(this);
        (_a = this.el) === null || _a === void 0 ? void 0 : _a.remove();
    };
    /**
     * 显示poster，可以传入图片地址展示不同的图片。
     * @param src {string} 需要展示的poster图片地址。
     */
    PosterPlugin.prototype.show = function (src) {
        if (!this.el)
            return;
        if (src) {
            this.el.src = src;
        }
        this.el.classList.remove(hideClass);
    };
    /**
     * 显示指定vid的poster
     */
    PosterPlugin.prototype.showByVid = function (_a) {
        var vid = _a.vid, vidFirstPic = _a.vidFirstPic, h5Defn = _a.h5Defn, dir = _a.dir, resolution = _a.resolution; _a.pcFmt;
        if (!vid)
            return;
        var src = findPoster({ vid: vid, vidFirstPic: vidFirstPic, h5Defn: h5Defn, dir: dir, resolution: resolution });
        this.show(src);
    };
    /** 隐藏poster */
    PosterPlugin.prototype.hide = function () {
        if (!this.el)
            return;
        this.el.classList.add(hideClass);
    };
    PosterPlugin.prototype.hookAdPlaying = function () {
        this.hide();
    };
    PosterPlugin.prototype.hookVideoPlaying = function (param) {
        if (param.isFirst) {
            this.hide();
        }
    };
    PosterPlugin.prototype.hookVideoEnd = function (param) {
        if (param.endState === END_STATE.NORMAL && !this.player.config.loop) {
            // 非出错状态播放结束 && 不需要循环播放时，再次显示poster
            this.tryShow();
        }
    };
    PosterPlugin.prototype.init = function () {
        var _a;
        var container = this.player.container;
        var img = document.createElement('img');
        img.alt = POSTER_IMAGE_ALT;
        img.classList.add(POSTER_IMAGE_CLASS_NAME, hideClass);
        if (this.objectFitMode) {
            domTool.css(img, { objectFit: this.objectFitMode });
        }
        container.prepend(img);
        var zIndex = (_a = this.config) === null || _a === void 0 ? void 0 : _a.zIndex;
        if (zIndex > 0) {
            domTool.css(img, { zIndex: zIndex });
        }
        return img;
    };
    PosterPlugin.prototype.tryShow = function () {
        var _a, _b;
        // 如果有vid，优先使用vid
        if ((_a = this.config) === null || _a === void 0 ? void 0 : _a.vid) {
            this.showByVid(this.config);
        }
        else if ((_b = this.config) === null || _b === void 0 ? void 0 : _b.src) {
            this.show(this.config.src);
        }
    };
    PosterPlugin.pluginName = PosterPluginName;
    return PosterPlugin;
}(Plugin));

H5Player.registerPlugin(PosterPlugin.pluginName, PosterPlugin);

export { DEFAULT_RES, PosterPlugin, findPoster };
